import { palette } from "../palette"

export const MuiInputLabel = {
  styleOverrides: {
    shrink: {
      "&.Mui-focused": {
        color: palette.info,
      },
    },
  },
}
